import Swiper from 'swiper/bundle';

const recentlyViewed = {
	cookieName: 'recently_viewed_products',
	maxItems: 11,

	getLocale() {
		return document.documentElement.lang || 'uk';
	},

	getProductUrl() {
		return this.getLocale() === 'ru'
			? '/ru/pages/products-to-fetch/recently_viewed'
			: '/pages/products-to-fetch/recently_viewed';
	},

	getCookie(name) {
		const matches = document.cookie.match(
			new RegExp('(?:^|; )' + name.replace(/([$?*|{}\[\]\\/+^])/g, '\\$1') + '=([^;]*)')
		);
		return matches ? decodeURIComponent(matches[1]) : null;
	},

	setCookie(name, value, days = 30) {
		const d = new Date();
		d.setTime(d.getTime() + days * 86400000);
		document.cookie = `${name}=${encodeURIComponent(value)}; path=/; expires=${d.toUTCString()}; secure; SameSite=Lax`;
	},

	pushCurrentProduct() {
		const el = document.getElementById('productViewedData');
		if (!el) return;

		let product;
		try {
			product = JSON.parse(el.textContent);
		} catch {
			return;
		}

		let data = [];
		try {
			data = JSON.parse(this.getCookie(this.cookieName) || '[]');
		} catch {}

		data = data.filter(p => p.id !== product.id);
		data.unshift(product);
		if (data.length > this.maxItems) data.pop();

		this.setCookie(this.cookieName, JSON.stringify(data));
	},

	async fetchHtml() {
		const res = await fetch(this.getProductUrl());
		return res.text();
	},

	extractCards(html, ids) {
		const doc = new DOMParser().parseFromString(html, 'text/html');
		return ids
			.map(id =>
				doc.querySelector(`.product-card[data-productkey="${id}"]`)
			)
			.filter(Boolean)
			.map(el => `
        <div class="swiper-slide">
          ${el.outerHTML}
        </div>
      `);
	},

	initSwiper(container) {

		let sliderMaxColumns = 4;
		if (window.location.href.includes('a/products')) {
			sliderMaxColumns = 3;
		}

		return new Swiper(container, {
			loop: true,
			speed: 500,
			slidesPerView: 4,
			spaceBetween: 24,
			watchOverflow: true,

			pagination: {
				el: ".recently-viewed .slider-pagination",
				bulletClass: 'slider-pagination__bullet',
				bulletActiveClass: 'slider-pagination__bullet--active',
				clickable: true
			},
			navigation: {
				prevEl: ".recently-viewed .slider-controls__btn--prev",
				nextEl: ".recently-viewed .slider-controls__btn--next",
			},

			breakpoints: {
				100: {
					slidesPerView: 1.2,
					spaceBetween: 10
				},
				350: {
					slidesPerView: 1.25,
					spaceBetween: 16
				},
				650: {
					slidesPerView: 2,
					spaceBetween: 16
				},
				900: {
					slidesPerView: 3,
					spaceBetween: 24
				},
				1025: { slidesPerView: sliderMaxColumns-1 },
				1200: { slidesPerView: sliderMaxColumns }
			}
		});
	},

	async render() {
		const section = document.querySelector('.recently-viewed');
		if (!section) return;

		const grid = section.querySelector('.recently-viewed__grid');
		const wrapper = grid.querySelector('.swiper-wrapper');
		let products;
		try {
			products = JSON.parse(this.getCookie(this.cookieName) || '[]');
		} catch {
			section.remove();
			return;
		}

		if (!products.length) {
			section.remove();
			return;
		}

		const html = await this.fetchHtml();
		const slides = this.extractCards(html, products.map(p => p.id));

		if (!slides.length) {
			section.remove();
			return;
		}

		wrapper.innerHTML = slides.join('');
		this.initSwiper(grid);
		document.dispatchEvent(new CustomEvent('content:updated'));
	},

	init() {
		this.pushCurrentProduct();
		this.render();
	}
};

export function initRecentlyViewed() {
	recentlyViewed.init();
}

